module.exports = __webpack_public_path__ + "img/59.end_clean_zone.215e1814.svg";